<template>
  <!--srccomponentsgui_mark_totalgui_mark_totalvuehtmlStart-->

  <div
    id="defaultId1"
    class="trade_middle_top_item_box"
    :class="
      $route.query.Moudles == 'Trade'
        ? ' trade_middle_top_item_bg'
        : $route.meta.title == 'companyDetails'
        ? ' search_middle_top_item_bg'
        : ''
    "
  >
    <div id="ge25b1" class="u3da49">
      <div class="text_label">
        {{ total  }}    <!-- | FilterNum -->
      </div>
    </div>

    <div
      v-if="$route.query.Moudles == 'Trade'"
      id="g87d25"
      :class="
        $route.query.Moudles == 'Trade'
          ? 'trade_middle_top_item_text'
          : 'u8dd69'
      "
    >
      {{ label }}
    </div>
    <div
      v-else-if="$route.meta.title == 'companyDetails'"
      id="g87d25"
      :class="
        $route.meta.title == 'companyDetails'
          ? 'trade_middle_top_item_text'
          : 'u8dd69'
      "
    >
      {{ label }}
    </div>
    <el-tooltip
      v-else
      :disabled="total.length < 50"
      :content="total | FilterNum"
      placement="top"
    >
      <div
        id="g87d25"
        :class="
          $route.query.Moudles == 'Trade'
            ? 'trade_middle_top_item_text'
            : 'u8dd69'
        "
      >
        {{ label }}
      </div>
    </el-tooltip>
  </div>
  <!--srccomponentsgui_mark_totalgui_mark_totalvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

//importEnd

export default {
  name: "",
  props: {
    // srccomponentsgui_mark_totalgui_mark_totalvuePropsStart

    //
    label: {
      type: String,
      default: "",
    },
    MoudeImg: {
      type: String,
      default: "images/jiugonggeBg.png",
    },
    total: {
      type: [String, Number],
      default: null,
    },
    // srccomponentsgui_mark_totalgui_mark_totalvuePropsEnd
  },
  mounted() {},
  components: {},
  data() {
    return {};
  },
  methods: {
    default() {},
  },
  computed: {},
};
</script>
<style>
.trade_middle_top_item_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 80px;
  background-size: 100% 100%;
  pointer-events: auto;
  border-radius: 5px;
  gap: 10px;
}
.trade_middle_top_item_bg,
.search_middle_top_item_bg {
  min-height: 80px !important;
  background-size: 100% 100%;
  pointer-events: auto;
  padding: 5px;
}
.trade_middle_top_item_bg {
  background: #eafafa;
}
.search_middle_top_item_bg {
  background: #e6f4ff;
}
.u3da49 {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text_label {
  font-size: 20px;
  color: #1290c9;
  width: fit-content;
  font-family: "Arial Bold";
}
.trade_middle_top_item_bg .text_label {
  color: #009ea7;
}
.trade_layout .trade_middle_top_item_bg .text_label {
  color: #009ea7;
}

.trade_middle_top_item_text {
  color: #1a2332;
  font-size: 16px;
  text-align: center;
  width: 100%;
}
.u8dd69 {
  font-size: 1.14285714rem;
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1920px) {
  .text_label,
  .u8dd69Trade,
  .u8dd69 {
    font-size: 16px;
  }

  .u661e6 {
    margin-left: 4px;
    margin-right: 4px;
    padding: 5px;
  }
  .trade_middle_top_item_text {
    font-size: 14px;
  }
  .trade_middle_top_item_bg,
  .search_middle_top_item_bg {
    padding: 5px 20px;
    min-height: 60px !important;
  }
}
@media screen and (max-width: 1439px) {
  .trade_middle_top_item_text {
    font-size: 12px;
  }
  .text_label,
  .u8dd69Trade,
  .u8dd69 {
    font-size: 14px;
  }
}
</style>
